module.exports = __webpack_public_path__ + "static/media/bigEvent.fd629f5a.jpg";